export const LogOutIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.4998 4C15.4998 3.86193 15.3878 3.75 15.2498 3.75H7.24976C6.83554 3.75 6.49976 3.41421 6.49976 3C6.49976 2.58579 6.83554 2.25 7.24976 2.25H15.2498C16.2163 2.25 16.9998 3.0335 16.9998 4V16C16.9998 16.9665 16.2163 17.75 15.2498 17.75H7.24976C6.83554 17.75 6.49976 17.4142 6.49976 17C6.49976 16.5858 6.83554 16.25 7.24976 16.25H15.2498C15.3878 16.25 15.4998 16.1381 15.4998 16V4ZM11 9.25C11.4142 9.25 11.75 9.58579 11.75 10C11.75 10.4142 11.4142 10.75 11 10.75H6H5.56066L6.28033 11.4697C6.57322 11.7626 6.57322 12.2374 6.28033 12.5303C5.98744 12.8232 5.51256 12.8232 5.21967 12.5303L3.21967 10.5303C2.92678 10.2374 2.92678 9.76256 3.21967 9.46967L5.21967 7.46967C5.51256 7.17678 5.98744 7.17678 6.28033 7.46967C6.57322 7.76256 6.57322 8.23744 6.28033 8.53033L5.56066 9.25L6 9.25H11Z"
        fill="#3E3E3E"
      />
    </svg>
  )
}
